<template>
  <div class="add-page">
    <van-nav-bar title="添加学生" />
    <div class="ap-conts">
      <div class="ap-lable">学生姓名:</div>
      <div class="box-2 flex-row" style="justify-content: center; align-items: center">
        <input
          placeholder="请输入"
          v-model="studentName"
          class="device-input"
          style="margin-bottom: 0px"
        />
        <div class="tip">
          <span class="tip-span" v-if="showname">请输入学生姓名</span>
        </div>
      </div>

      <div class="ap-lable" style="margin-top: 10px">学生身份证号码：</div>
      <div class="box-2 flex-row" style="justify-content: center; align-items: center">
        <input
          placeholder="请输入18位身份证号码"
          type="text"
          v-model="certNo"
          @input="getInput"
          class="device-input"
        />
      </div>

      <div class="tip">
        <span class="tip-span" v-if="showspan">请输入正确的身份证号码</span>
        <span class="tip-span" v-else></span>
        <span>信息严格保密，保护隐私安全</span>
      </div>
    </div>

    <div style="margin: 50px 12px">
      <van-button block type="info" native-type="submit" @click="bindDevice">查找学生</van-button>
    </div>
    <div class="ap-nodata" v-if="!studentInfo && showNodata === '0'">
      未找到该学生信息，请检查输入的学生口令是否正确，联系班主任或客服~
    </div>

    <div class="ap-info" v-if="studentInfo">
      <div class="info-box">
        <img class="imgs" src="../../assets/images/student.png" />
        <div class="neme-box">
          <div class="names">{{ studentInfo.studentName }}</div>
          <div>
            {{ studentInfo.schoolName }}{{ studentInfo.gradeName }}{{ studentInfo.className }}
          </div>
        </div>
      </div>
      <div class="btn-box">
        <van-button block type="info" native-type="submit" @click="bindOK">确认</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Toast, NavBar } from 'vant'
export default {
  data() {
    return {
      studentName: '',
      certNo: '',
      showspan: false,
      showname: false,
      studentInfo: null,
      showNodata: '',
      rge: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    }
  },
  created() {
    // this.$http.json_post(this.$api.login.testwxmain, {}).then((res) => {
    //   console.log('data', res)
    // })
  },

  methods: {
    bindDevice() {
      if (this.studentName === '') {
        return (this.showname = true)
      } else {
        this.showname = false
      }
      if (this.certNo === '' || !this.rge.test(this.certNo)) {
        return (this.showspan = true)
      } else {
        this.showspan = false
      }
      this.$http
        .json_post(this.$api.login.checkstudent, {
          studentName: this.studentName,
          certNo: this.certNo,
        })
        .then((data) => {
          if (data.code === 0) {
            this.studentInfo = data.data
          } else {
            this.showNodata = '0'
            Toast.fail(data.msg)
          }
        })
    },

    bindOK() {
      this.$router.push({ name: 'addfamily', query: { studentId: this.studentInfo.studentId } })
    },

    getInput() {
      setTimeout(() => {
        let that = this
        if (that.rge.test(that.certNo)) {
          that.showspan = false
        } else {
          that.showspan = true
        }
      }, 300)
    },
  },

  components: {
    'van-button': Button,
    'van-nav-bar': NavBar,
  },
}
</script>

<style lang="scss" scoped>
.add-page {
  font-family: PingFangSC, PingFang SC;
  .ap-conts {
    margin: 22px 12px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 17px 8px 8px 10px;
    .ap-lable {
      font-weight: 600;
      font-size: 16px;
      color: #2c2d32;
      line-height: 22px;
      margin-bottom: 5px;
    }
    .device-input {
      background: #ffffff;
      box-shadow: 0rpx 4px 10px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      border: 1px solid #6ebeff;
      width: calc(100% - 8px);
      height: 40px;
      margin-bottom: 10px;
    }
  }
  .tip {
    font-weight: 600;
    font-size: 10px;
    color: #616161;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tip-span {
      color: #fe5334;
    }
  }

  .ap-nodata {
    font-weight: 600;
    font-size: 10px;
    color: #616161;
    line-height: 22px;
    margin: 60px 80px;
    text-align: center;
  }

  .ap-info {
    margin: 23px 20px;
    background: #ffffff;
    padding: 13px 10px;
    .info-box {
      display: flex;
      align-items: center;
      .imgs {
        height: 70px;
        width: 70px;
        margin-right: 23px;
      }
    }
    .neme-box {
      font-weight: 500;
      font-size: 12px;
      color: #27293a;
      line-height: 17px;
      padding: 8px 0;
      height: 54px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .names {
        font-size: 14px;
      }
    }
  }
  .btn-box {
    padding: 20px 40px;
  }
}
</style>
